<app-account-actions pageTitle="">
  <div content>
    <app-not-found pageTitle="not found.label"></app-not-found>
    <div class="full-width mt-4">
      <ut-button variant="primary" (clicked)="nav.login()">{{ 'login.title' | translate }}</ut-button>
    </div>
    <div class="full-width mt-2">
      <ut-button variant="secondary" (clicked)="nav.signup()">{{ 'button.register' | translate }}</ut-button>
    </div>
  </div>
</app-account-actions>
